module.exports = __webpack_public_path__ + "img/76304.6048290e.svg";